/**
 * GA4 session hand-off to checkout (#364).
 *
 * Checkout runs the GTM pixel inside Shopify's Customer Events sandbox, which
 * only sees a snapshot of the page's cookies. When that snapshot has no live
 * GA4 session (or none at all, as on a shop.app-hosted checkout) GA4 starts a
 * fresh session at begin_checkout with no source, and the purchase lands in
 * Direct or Unassigned. Since cutover that was ~6% of revenue.
 *
 * This script stamps the storefront's GA cookies (`_ga` and every `_ga_<ID>`)
 * into one hidden cart attribute, `_ga_session`, at the moment a cart form is
 * submitted, so the native checkout POST carries them to the checkout for free.
 * The pixel (functions/pixels/gtm/GTM.js) reads the attribute off the checkout
 * and restores whichever session is freshest before it loads GTM.
 *
 * Capture-phase submit listener on the document: it covers the cart drawer
 * form, the bag page form and any future form that posts to the cart URL
 * (`/cart`, market-prefixed or not) without touching their markup. The value
 * is read at submit time so it is never stale. No GA cookies (consent not
 * granted, GTM never loaded) writes an empty value, which clears any
 * attribute left from an earlier session: the attribute never outlives the
 * cookies it mirrors. Underscore-prefixed, so Shopify hides it from the
 * customer on checkout, order status and notifications.
 */
(function () {
  if (window.__dcGaSessionHandoff) return;
  window.__dcGaSessionHandoff = true;

  var ATTRIBUTE = 'attributes[_ga_session]';

  function gaCookies() {
    var pairs = [];
    try {
      var parts = (document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i++) {
        var pair = parts[i].trim();
        var eq = pair.indexOf('=');
        if (eq < 1) continue;
        var name = pair.slice(0, eq);
        if (name !== '_ga' && name.indexOf('_ga_') !== 0) continue;
        pairs.push(name + '=' + pair.slice(eq + 1));
      }
    } catch (e) {
      // Cookies disabled: nothing to hand off.
    }
    return pairs.join('; ');
  }

  function isCartForm(form) {
    if (!form || String(form.method || '').toLowerCase() !== 'post') return false;
    var action = form.getAttribute('action') || '';
    try {
      return /\/cart$/.test(new URL(action, document.baseURI).pathname);
    } catch (e) {
      return false;
    }
  }

  function stamp(form) {
    var input = form.querySelector('input[name="' + ATTRIBUTE + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = ATTRIBUTE;
      form.appendChild(input);
    }
    input.value = gaCookies();
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isCartForm(form)) return;
      try {
        stamp(form);
      } catch (e) {
        // Never block checkout over analytics.
      }
    },
    true
  );
})();
